const translations = {
  "en": {
    "Manage": "Manage",
    "Manual upload": "Manual upload"
  },
  "zh-tw": {
    "Manage": "管理",
    "Manual upload": "手動上傳"
  }
};

export default translations;
